"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseExpenseTemplatePaymentMethods = exports.getExpenseTemplatePaymentMethodId = exports.AVAILABLE_PAYMENT_METHODS = void 0;
var _PaymentMethod = require("./PaymentMethod");
var AVAILABLE_PAYMENT_METHODS = exports.AVAILABLE_PAYMENT_METHODS = [{
  source: 'CASH'
}, {
  source: 'CORPORATE',
  type: 'CREDIT'
}, {
  source: 'CORPORATE',
  type: 'DEBIT'
}, {
  source: 'PERSONAL',
  type: 'CREDIT'
}, {
  source: 'PERSONAL',
  type: 'DEBIT'
}];
var getExpenseTemplatePaymentMethodId = exports.getExpenseTemplatePaymentMethodId = function getExpenseTemplatePaymentMethodId(item) {
  return (0, _PaymentMethod.getPaymentMethodId)(item.source, item.type);
};
var parseExpenseTemplatePaymentMethods = exports.parseExpenseTemplatePaymentMethods = function parseExpenseTemplatePaymentMethods(input) {
  return input.map(function (el) {
    var segments = el.split('|');
    if (segments.length === 0) {
      return undefined;
    }
    var source = segments[0];
    var type = undefined;
    if (segments.length > 1) {
      type = segments[1];
    }
    return {
      source: source,
      type: type
    };
  }).filter(function (el) {
    return !!el;
  }).map(function (el) {
    return el;
  });
};